// @flow
import { darken } from "polished"

export const darkenFactor: number = 0.1

export type Style = {
  danger: string,
  dangerText: string,
  dangerOutline: string,
  dangerHover: string,
  info: string,
  infoText: string,
  infoOutline: string,
  infoHover: string,
  primary: string,
  primaryText: string,
  primaryOutline: string,
  primaryHover: string,
  secondary: string,
  secondaryText: string,
  secondaryOutline: string,
  secondaryHover: string,
  success: string,
  successText: string,
  successOutline: string,
  successHover: string,
  warning: string,
  warningText: string,
  warningOutline: string,
  warningHover: string,
  link: string,
  linkText: string,
  linkOutline: string,
  linkHover: string,
  buttonRadius: string,
  modalHeadingTextTransform: string,
  accent: string,
  modalSectionPadding: string,
  labelTextTransform: string,
  backgroundGradientLight: string,
  backgroundGradientDark: string,
  foregroundText: string
}

const defaultStyle: Style = {
  danger: "#d9534f",
  dangerText: "#fff",
  dangerOutline: "#d9534f",
  dangerHover: darken(darkenFactor, "#d9534f"),
  info: "#5bc0de",
  infoText: "#fff",
  infoOutline: "#5bc0de",
  infoHover: darken(darkenFactor, "#5bc0de"),
  primary: "#0275d8",
  primaryText: "#fff",
  primaryOutline: "#0275d8",
  primaryHover: darken(darkenFactor, "#0275d8"),
  secondary: "#ccc",
  secondaryText: "#292b2c",
  secondaryOutline: "#ccc",
  secondaryHover: darken(darkenFactor, "#ccc"),
  success: "#5cb85c",
  successText: "#fff",
  successOutline: "#000",
  successHover: darken(darkenFactor, "#5cb85c"),
  warning: "#f0ad4e",
  warningText: "#fff",
  warningOutline: "#f0ad4e",
  warningHover: darken(darkenFactor, "#f0ad4e"),
  link: "transparent",
  linkText: "#0275d8",
  linkOutline: "transparent",
  linkHover: "transparent",
  buttonRadius: "0.25rem",
  modalHeadingTextTransform: "uppercase",
  accent: "#5bc0de",
  modalSectionPadding: "1rem 1.5rem",
  labelTextTransform: "uppercase",
  backgroundGradientLight: "#333",
  backgroundGradientDark: "#000",
  foregroundText: "#464a4c"
}

export default defaultStyle



// WEBPACK FOOTER //
// ./src/UI/Theme/index.js